module.exports = __webpack_public_path__ + "static/media/typeAVersion3.aaea5e67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hotspots/landing/typeAVersion3.png
// module id = 1247
// module chunks = 0